// imports
import * as THREE from "three"

// classes
import Experience from "../Experience"

export default class Fox
{
    constructor()
    {
        // setup
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resourceLoader = this.experience.resourceLoader

        this.setInstance()
    }

    setInstance()
    {
        this.resource = this.resourceLoader.items.foxModel
        this.instanceParameters =
        {
            scale:
            {
                x: 0.015,
                y: 0.015,
                z: 0.015
            }
        }
        this.instance = this.resource.scene
        this.instance.scale.set( ...Object.values( this.instanceParameters.scale ) )
        this.instance.traverse( ( child ) =>
        {
            if ( child instanceof THREE.Mesh )
            {
                child.castShadow = true
                child.receiveShadow = true
            }
        } )

        this.scene.add( this.instance )
    }

    setDebug()
    {
        this.folder = this.experience.world.worldFolder.addFolder( 
        {
            title: "Fox",
            expanded: false
        } ).on( "change", () => this.handleChange() )

        this.tabs = this.folder.addTab( 
        {
            pages:
            [
                { title: "Scale" },
            ]
        } )

        this.scaleFolder = this.tabs.pages[0]

        this.scaleFolder.addInput( this.instanceParameters.scale, "x",
        {
            min: Math.PI * 0.25,
            max: Math.PI * 4,
            step: 0.001
        } )
        this.scaleFolder.addInput( this.instanceParameters.scale, "y",
        {
            min: Math.PI * 0.25,
            max: Math.PI * 4,
            step: 0.001
        } )
        this.scaleFolder.addInput( this.instanceParameters.scale, "z",
        {
            min: Math.PI * 0.25,
            max: Math.PI * 4,
            step: 0.001
        } )
    }

    handleChange()
    {   
        this.instance.scale.set( ...Object.values( this.instanceParameters.scale ) )
    }
}